<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import {PayoutPath} from "@/path";
import Swal from "sweetalert2";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Payout Policy",
      items: [
        {
          text: "Policy",
        },
        {
          text: "Payout",
          active: true,
        },
      ],
      file : null,
      file2 : null,
      baseUrl : process.env.VUE_APP_API_BACKEND_URL
    };
  },
  methods : {
    async savePolicy(){
      try {
        let formData = new FormData();
        formData.append('file',this.file);
        formData.append('file2',this.file2);
        let res = await axios.post(this.baseUrl + PayoutPath.POST_POLICY,formData,{
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if(res.data.status){
          Swal.fire('success','','success');
        }
      }catch (err){
        console.log(err);
      }
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-body>
        <b-form-group>
          <label>Swiggy Csv File Upload</label>
          <b-form-file accept=".csv" @change="((e) => file = e.target.files[0])"></b-form-file>
        </b-form-group>
        <b-form-group>
          <label>Zomato Csv File Upload</label>
          <b-form-file accept=".csv" @change="((e) => file2 = e.target.files[0])"></b-form-file>
        </b-form-group>
        <b-form-group>
          <b-button variant="success" @click="savePolicy">Submit</b-button>
        </b-form-group>
      </b-card-body>
    </b-card>
  </Layout>
</template>
